<template>
  <div>
    <div class="blue-subhead-bg text-uppercase">
      <h1>Rewards</h1>
    </div>

    <div class="container admin-users">
      <br>
      <div class="np-left-push hidden-xs">
        <div class="row">
          <div class="col-sm-2 clickable text-center" @click="sortItems(['username'])"><strong>Username</strong></div>
          <div class="col-sm-2 clickable text-center" @click="sortItems(['name'])"><strong>Item Name</strong></div>
          <div class="col-sm-1 clickable text-center" @click="sortItems(['color'])"><strong>Item Color</strong></div>
          <div class="col-sm-1 clickable text-center" @click="sortItems(['quanitity'])"><strong>Quantity</strong></div>
          <div class="col-sm-2 clickable text-center" @click="sortItems(['trackingNumber'])"><strong>Tracking Number</strong></div>
          <div class="col-sm-2 clickable text-center" @click="sortItems(['shippingDate'])"><strong>Shipping Date</strong></div>
          <div class="col-sm-1 clickable text-center" @click="sortItems(['shipped'])"><strong>Shipped</strong></div>
          <div class="col-sm-1 text-center"></div>
        </div>
      </div>

      <div class="blue-outline-nh" v-for="(rewardItem, index) in rewardItems" :key="index">
        <div class="row v-center-row">
          <div class="col-sm-2 text-center"><span class="visible-xs-inline-block"><strong>Username:</strong></span> {{ rewardItem.username }}</div>
          <div class="col-sm-2 text-center"><span class="visible-xs-inline-block"><strong>Item Name:</strong></span> {{ rewardItem.name }}</div>
          <div class="col-sm-1 text-center"><span class="visible-xs-inline-block"><strong>Color: </strong></span> {{ rewardItem.color || 'N/A' }}</div>
          <div class="col-sm-1 text-center"><span class="visible-xs-inline-block"><strong>Quantity:</strong></span> {{ rewardItem.quantity }}</div>
          <div class="col-sm-2 text-center">
            <input
              class="form-control admin-form-control"
              @blur="updateProgramItemTracking(rewardItem)"
              v-model="rewardItem.trackingNumber"
              placeholder="Tracking Number">
          </div>
          <div class="col-sm-2 datepicker-input">
            <datepicker
              v-model="rewardItem.shippingDate"
              input-class="reward-datepicker-input form-control admin-form-control input-md"
              placeholder="Shipping Date"
              @closed="updateProgramItemShippingDate(rewardItem)">
            >
            </datepicker>
          </div>
          <div class="col-sm-1 text-center">
            <input
              type="checkbox"
              v-model="rewardItem.shipped"
              :disabled="!rewardItem.trackingNumber || !rewardItem.shippingDate"
              @change="updateProgramItemShipped(rewardItem)">
          </div>
          <div class="col-sm-1 text-center">
            <span
              class="clickable glyphicon glyphicon-envelope"
              @click="sendEmail(rewardItem)"
              ></span>
          </div>
        </div>
      </div>

      <!-- pagination -->
      <!-- <div class="row">
        <div class="col-sm-6 col-sm-offset-3 text-center">
          <nav aria-label="Page navigation">
            <ul class="pagination">
              <li>
                <a href="#" aria-label="Previous">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li><a href="#">1</a></li>
              <li><a href="#">2</a></li>
              <li><a href="#">3</a></li>
              <li><a href="#">4</a></li>
              <li><a href="#">5</a></li>
              <li>
                <a href="#" aria-label="Next">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <br>
      </div> -->
      <br><br>
      <br>
      <router-link :to="{name: 'EditLoyaltyProgram'}" class="btn btn-lg admin-btn-primary col-md-2 col-md-offset-10">Back</router-link>
      <div class="clearfix"></div>
      <br>
    </div><!-- container-fluid -->
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import moment from 'moment'
import axios from 'axios'
import Datepicker from 'vuejs-datepicker'

axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')

const _ = require('lodash')

export default {
  name: 'RewardItemSubmissions',
  components: {
    Datepicker
  },
  data () {
    return {
      sort: {
        properties: [],
        reverse: false
      },
      rewardItems: []
    }
  },
  computed: {
    ...mapGetters('loyaltyProgram', [
      'programId',
      'unapprovedReceiptItems'
    ]),
    ...mapState('loyaltyProgram', {
      program: state => state.program
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    ...mapActions('loyaltyProgram', [
      'getReceiptsByLoyaltyProgramId',
      'saveProgram'
    ]),
    ...mapActions('cartRewardItem', [
      'adminUpdateCartRewardItem'
    ]),
    init () {
      this.rewardItems = this.program.userLoyaltyPrograms.reduce((items, ulp, idx) => {
        const modifiedCart = ulp.cart.map(cartItem => {
          return Object.assign({}, cartItem, { username: ulp.user.username, ulpId: ulp._id })
        })
        return [...items, ...modifiedCart]
      }, [])
      this.sortItems(['shipped'])
    },
    formatDate (date) {
      return moment(date).format('MM/DD/YYYY').toString()
    },
    goReceiptItemDetail (receiptItem) {
      this.$router.push({ name: 'ReceiptItemDetail', params: { receiptItem } })
    },
    sortItems (properties) {
      this.sort.reverse = properties[0] === this.sort.properties[0] ? !this.sort.reverse : false
      this.sort.properties[0] = properties[0]
      if (this.sort.properties.length > 0) {
        if (this.sort.reverse) {
          this.rewardItems = _.sortBy(this.rewardItems, properties).reverse()
        } else {
          this.rewardItems = _.sortBy(this.rewardItems, properties)
        }
      }
    },
    updateProgramItemTracking (rewardItem) {
      const programItem = this.program.userLoyaltyPrograms
        .find(ulp => ulp._id === rewardItem.ulpId).cart
        .find(cartItem => cartItem._id === rewardItem._id)
      programItem.trackingNumber = rewardItem.trackingNumber
      this.save(rewardItem.ulpId, rewardItem, false)
    },
    updateProgramItemShipped (rewardItem) {
      const programItem = this.program.userLoyaltyPrograms
        .find(ulp => ulp._id === rewardItem.ulpId).cart
        .find(cartItem => cartItem._id === rewardItem._id)
      programItem.shipped = rewardItem.shipped
      this.save(rewardItem.ulpId, rewardItem, true)
    },
    updateProgramItemShippingDate (rewardItem) {
      const programItem = this.program.userLoyaltyPrograms
        .find(ulp => ulp._id === rewardItem.ulpId).cart
        .find(cartItem => cartItem._id === rewardItem._id)
      programItem.shippingDate = rewardItem.shippingDate
      this.save(rewardItem.ulpId, rewardItem, true)
    },
    save (ulpId, cartItem, email) {
      this.adminUpdateCartRewardItem({ userLoyaltyProgramId: ulpId, cartItem })
        .then(response => {
          this.$bus.emit('notify', { message: 'Successfully saved!', type: 'info' })
        })
        .catch(err => {
          this.$bus.emit('notify', { message: 'Failed to save!', type: 'danger' })
          console.log(err)
        })
    },
    sendEmail (cartItem) {
      if (!cartItem.trackingNumber || !cartItem.shippingDate || !cartItem.shipped) {
        alert('The "Tracking Number" field, "Shipping Date" field, and the "Shipped" checkbox must be filled.')
        return
      }

      const verified = confirm('Are you sure you want to send the shipped notification email?')
      if (!verified) return

      const userLoyaltyProgram = this.program.userLoyaltyPrograms
        .find(ulp => ulp._id === cartItem.ulpId)

      axios.post(
        `${process.env.VUE_APP_SERVER_HOST}/api/common/mailer/cartItemShipped`,
        {
          emailInfo: {
            to: userLoyaltyProgram.user.email,
            trackingNumber: cartItem.trackingNumber,
            date: this.formatDate(cartItem.shippingDate),
            company: this.program.company.name
          }
        }
      )
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>
<style>
.reward-datepicker-input {
  background-color: white !important;
}

</style>

<style scoped>
input[type="checkbox"] {
  font-size: 16px;
}

.col-md-offset-7-5 {
  margin-left: 62.5%;
}
.col-md-offset-half {
  margin-left: 4.16666667%;
}
.v-center-row {
  display: flex;
  align-items: center;
}
</style>
